import { PlantLayoutAreaDrawingsThemeSizeConfig } from './types';

const large: PlantLayoutAreaDrawingsThemeSizeConfig = {
  plantLayoutAreaDrawings: {},
};

export default large;
